<template>
  <div class="alert-table">
    <div class="options-bar">
      <RexTabsV3
        :tabs="toggleOptions"
        @onTabChange="tabChange"
        :activeKey="selectedOption"
        class="tab-comp"
      >
        <!-- Tab 1 Content -->
        <template #tab-1>
          <TabContent :headers="tab1Header" :data="alertsData" />
        </template>

        <!-- Tab 2 Content -->
        <template #tab-2>
          <TabContent :headers="tab2Header" :data="totalAlertsData" />
        </template>
      </RexTabsV3>
    </div>
  </div>
</template>

<script>
import {
  alertTableHeaderForDbByConnections,
  alertTableHeaderForErrorFunctions,
  alertTableHeaderForInvocatedFunctions,
  alertTableHeaderForMetricsByAlerts,
  alertTableHeaderForSubscriptionByAlerts,
  alertTableType,
} from '@/components/Cloud/Dashboard/cloud.types';
import RexTabsV3 from '@/rex-components/RexTabsV3.vue';
import TabContent from '@/components/Cloud/Dashboard/Components/alerts-tabs-content.vue';

export default {
  name: 'AWSAlertTable',
  components: { RexTabsV3, TabContent },
  props: {
    toggleOptions: {
      type: Array,
      required: true,
    },
    alertsData: {
      type: Array,
      required: true,
    },
    totalAlertsData: {
      type: Array,
      required: true,
    },
    alertType: {
      type: String,
      default: 'subscritpion',
      required: true,
    },
  },
  data() {
    return {
      headers: [],
      selectedOption: '1',
      alertTableHeaderForMetricsByAlerts,
      alertTableHeaderForSubscriptionByAlerts,
      alertTableHeaderForDbByConnections,
      alertTableType,
    };
  },
  methods: {
    tabChange(key) {
      this.selectedOption = key;
    },
  },
  computed: {
    tab1Header() {
      return this.alertType === alertTableType.subscription
        ? alertTableHeaderForSubscriptionByAlerts()
        : this.alertType === alertTableType.instance
          ? alertTableHeaderForDbByConnections()
          : alertTableHeaderForErrorFunctions();
    },
    tab2Header() {
      return this.alertType === alertTableType.subscription
        ? alertTableHeaderForMetricsByAlerts()
        : this.alertType === alertTableType.instance
          ? alertTableHeaderForMetricsByAlerts()
          : alertTableHeaderForInvocatedFunctions();
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-table {
  background-color: $bg-dark-black;
  padding: 1rem;
  border-radius: 0.5rem;
}

.options-bar {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
  position: relative;
  color: white;
}

.options-bar span {
  margin: 0 1rem;
  font-size: 14px;
  cursor: pointer;
}

.option-indicator {
  position: absolute;
  bottom: -0.2rem;
  width: 50%;
  height: 0.2rem;
  background-color: $color-brand-accent;
  transition: left 0.3s ease-in-out;
}

.options-bar span.active {
  color: $color-brand-accent;
}

.tab-comp-container {
  min-height: 9rem;
  max-height: 9rem;
  overflow-y: auto;
}

.tab-comp {
  width: 30rem;
  border-collapse: collapse;
}

.tab-comp th,
.tab-comp td {
  padding: 0.5rem;
  text-align: left;
}

.no-data-message {
  color: #ccc;
  text-align: center;
  margin-top: 1rem;
}
</style>
